import { translate } from '../i18n/index.js';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { slotsApi } from '../api/slots.api.js';
import type { AvailableSlot } from '@atomfit/shared';

export function useSlots(gymId: string | null, date: string | null) {
  const [slots, setSlots] = useState<AvailableSlot[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!gymId || !date) {
      setSlots([]);
      setLoading(false);
      setError(null);
      return;
    }

    const controller = new AbortController();
    let isCurrentRequest = true;

    setSlots([]);
    setLoading(true);
    setError(null);
    slotsApi
      .list(gymId, date, controller.signal)
      .then((res) => {
        if (isCurrentRequest) setSlots(res.data.data);
      })
      .catch((err: unknown) => {
        if (!isCurrentRequest || axios.isCancel(err)) return;
        setError(
          err instanceof Error
            ? err.message
            : translate('hooks.use_slots.load_slots.error_fallback'),
        );
      })
      .finally(() => {
        if (isCurrentRequest) setLoading(false);
      });

    return () => {
      isCurrentRequest = false;
      controller.abort();
    };
  }, [gymId, date]);

  return { slots, loading, error };
}
